import { UseQueryResult } from 'react-query';
import { NotificationsQuery } from 'src/graphql';
import { NavbarVariantEnum } from 'src/types';
import { NotificationsDrawer } from '../../NotificationsDrawer';
import { useNavbarContext } from '../NavbarProvider';

export const NotificationsList = ({
  notifications,
  variant,
  organisation,
  atlasVariant,
}: {
  notifications: UseQueryResult<NotificationsQuery, unknown>;
  variant: NavbarVariantEnum;
  organisation?: string;
  atlasVariant?: boolean;
}) => {
  const { isOpen, isSecondaryDrawerOpen, setSecondaryDrawerOpen } =
    useNavbarContext();

  return (
    <NotificationsDrawer
      isOpen={isSecondaryDrawerOpen}
      setIsOpen={setSecondaryDrawerOpen}
      notifications={notifications}
      navOpen={isOpen}
      variant={variant}
      organisation={organisation}
      atlasVariant={atlasVariant}
    />
  );
};
